export const SET_HUB_LIST = "SET_HUB_LIST";
export const RESET_HUB_STATE = "RESET_HUB_STATE";
export const SET_HUB_UUIDS = "SET_HUB_UUIDS";
export const SET_RELAY_TOKENS = "SET_RELAY_TOKENS";
export const SET_CONNECTION_STATUS = "SET_CONNECTION_STATUS";
export const RESET_CONNECTION_STATUS = "RESET_CONNECTION_STATUS";
